import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice, createAction } from '@reduxjs/toolkit';
import type { IOrder } from './types';
import { CancelRequestStatus } from './types';

export const name = 'order';

const initialState: IOrder = {
  info: {},
  cancellationReasons: [],
  cancellRequestStatus: CancelRequestStatus.UNDEFINED,
  changesRequestStatus: CancelRequestStatus.UNDEFINED,
  changes: '',
  customReasonText: '',
  changesTouristsRequestStatus: CancelRequestStatus.UNDEFINED,
};

const reducers = {
  setOrderInfo: (state: IOrder, action: PayloadAction<IOrder['info']>) => {
    state.info = action.payload;
  },
  setCancellationReasons: (
    state: IOrder,
    action: PayloadAction<IOrder['cancellationReasons']>,
  ) => {
    state.cancellationReasons = action.payload;
  },
  setSelectedCancelReason: (
    state: IOrder,
    action: PayloadAction<IOrder['selectedCancelReason']>,
  ) => {
    state.selectedCancelReason = action.payload;
  },
  setCancellRequestStatus: (
    state: IOrder,
    action: PayloadAction<IOrder['cancellRequestStatus']>,
  ) => {
    state.cancellRequestStatus = action.payload;
  },
  setChangesRequestStatus: (
    state: IOrder,
    action: PayloadAction<IOrder['changesRequestStatus']>,
  ) => {
    state.changesRequestStatus = action.payload;
  },
  setChanges: (state: IOrder, action: PayloadAction<IOrder['changes']>) => {
    state.changes = action.payload;
  },
  setCustomReasonText: (
    state: IOrder,
    action: PayloadAction<IOrder['customReasonText']>,
  ) => {
    state.customReasonText = action.payload;
  },
  setChangesTouristsRequestStatus: (
    state: IOrder,
    action: PayloadAction<IOrder['changesTouristsRequestStatus']>,
  ) => {
    state.changesTouristsRequestStatus = action.payload;
  },
};
const packageUpsaleOptions = createSlice({
  name,
  initialState,
  reducers,
});

export const {
  setOrderInfo,
  setCancellationReasons,
  setSelectedCancelReason,
  setCancellRequestStatus,
  setChanges,
  setChangesRequestStatus,
  setCustomReasonText,
  setChangesTouristsRequestStatus,
} = packageUpsaleOptions.actions;

export const fetchOrderInfo = createAction(`${name}/fetchOrderInfo`);

export const cancellOrder = createAction(`${name}/cancellOrder`);

export const changesOrder = createAction(`${name}/changesOrder`);

export const touristChangesOrder = createAction(`${name}/touristChangesOrder`);

export const submitTouristChange = createAction<any>(
  `${name}/submitTouristChange`,
);

export const fetchCancellationReasons = createAction(
  `${name}/fetchCancellationReasons`,
);

export default packageUpsaleOptions.reducer;
